import React, { useState, useEffect, createContext, memo } from "react";

//Librerias
import Cookies from "js-cookie";

//Context
export const AuthContext = createContext();

const Auth = ({ children }) => {
    const [data, setData] = useState({
        token: undefined,
        strData: undefined,
        informacionCambiada: false,
        btTienePerfilProfesional: true,
        btHVCargada: false,
    });

    const handlerChangeData = (type, value) => {
        setData((prevState) => ({
            ...prevState,
            [type]: value,
        }));
    };

    const cerrarSesion = () => {
        setData({
            token: undefined,
            strData: undefined,
        });
        if (
            !process.env.REACT_APP_NODE_ENV ||
            process.env.REACT_APP_NODE_ENV !== "production"
        ) {
            Cookies.remove("token");
        } else {
            Cookies.remove("token", {
                domain: ".choucairtesting.com",
            });
        }
        localStorage.removeItem("token");
    };

    const cambiosEnLaInformacion = () => {
        setData((prevState) => ({
            ...prevState,
            informacionCambiada: true,
        }));
    };

    const guardaCambiosDeLaInformacion = () => {
        setData((prevState) => ({
            ...prevState,
            informacionCambiada: false,
        }));
    };

    useEffect(() => {
        if (localStorage.getItem("token") && !Cookies.get("token")) {
            Cookies.set("token", localStorage.getItem("token"));
        }

        setData((prevState) => ({
            ...prevState,
            token: localStorage.getItem("token") || Cookies.get("token"),
        }));
    }, []);

    return (
        <AuthContext.Provider
            value={{
                token: data.token,
                strInfoUser: data.strData,
                informacionCambiada: data.informacionCambiada,
                btTienePerfilProfesional: data.btTienePerfilProfesional,
                btHVCargada: data.btHVCargada,
                handlerChangeData,
                cerrarSesion,
                cambiosEnLaInformacion,
                guardaCambiosDeLaInformacion,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default memo(Auth);
